import {
  Box,
  Button,
  Typography,
  Dialog,
  Grid,
  FormControl,
  Container,
  CssBaseline,
  Autocomplete,
  TextField,
} from "@mui/material";
import { LoadingButtonText } from "../../common";

export function UpdateApproverModal(props) {
  const disabled =
    props.isSubmitting ||
    (props.chefEmailTextfield === "" &&
      props.executiveChefEmailSelect === "" &&
      props.HODDepartmentSelect === "");

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        style={{
          height: "90%",
        }}
        PaperProps={{ sx: { borderRadius: "20px", width: "400px" } }}
      >
        <Box
          sx={{
            display: props.display,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Container
            component="main"
            maxWidth="sm"
            sx={{
              marginTop: 4,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography>
              Select Updated
              {props.approverType === "executiveChef" && " Executive Chef"}
              {props.approverType === "hod" && " HOD"}
            </Typography>
            <CssBaseline />
            <Box
              component="form"
              noValidate
              sx={{
                mt: 5,
              }}
            >
              <Grid container spacing={2}>
                {props.approverType === "chef" && (
                  <Grid item xs={12} sm={12}>
                    <TextField
                      autoFocus
                      margin="dense"
                      name="chefEmailTextfield"
                      id="chefEmailTextfield"
                      label="Chef Email "
                      fullWidth
                      onChange={props.handleChefEmailTextField}
                      required
                      error={props.errors?.chefEmail && true}
                      helperText={
                        props.errors?.chefEmail !== ""
                          ? props.errors?.chefEmail
                          : " "
                      }
                    />
                  </Grid>
                )}
                {props.approverType === "executiveChef" && (
                  <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                      <Autocomplete
                        id="grouped-executive-chef-email-select-sample-request-details-autocomplete"
                        onChange={(e, newValue) =>
                          props.handleExecChefEmailSelect(newValue)
                        }
                        loading={(props.executiveChefList?.length ?? 0) === 0}
                        options={props.executiveChefList}
                        groupBy={(option) => option.department}
                        getOptionLabel={(option) =>
                          `${option.name} (${option.email})`
                        }
                        fullWidth
                        renderOption={(props, option) => (
                          <Grid {...props} container ml={3} mb={2}>
                            <Grid item xs={12}>
                              {option.name}
                            </Grid>
                            <Grid item xs={12}>
                              <small>{option.email}</small>
                            </Grid>
                          </Grid>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} label="Executive Chef Email" />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
                {props.approverType === "hod" && (
                  <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                      <Autocomplete
                        id="grouped-hod-department-select-sample-request-details-autocomplete"
                        onChange={(e, newValue) =>
                          props.handleHODDepartmentSelect(newValue)
                        }
                        loading={(props.hodList?.length ?? 0) === 0}
                        options={props.hodList}
                        groupBy={(option) => option.department}
                        getOptionLabel={(option) =>
                          `${option.department}: ${option.name} (${option.email})`
                        }
                        fullWidth
                        renderOption={(props, option) => (
                          <Grid {...props} container ml={3} mb={2}>
                            <Grid item xs={12}>
                              {option.name}
                            </Grid>
                            <Grid item xs={12}>
                              <small>{option.position}</small>
                            </Grid>
                            <Grid item xs={12}>
                              <small>{option.email}</small>
                            </Grid>
                          </Grid>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} label="HOD Email" />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 1,

                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Grid item>
                  <Button
                    onClick={props.handleSubmit}
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 3,
                      width: "150px",
                    }}
                    disabled={disabled}
                  >
                    <LoadingButtonText
                      loading={props.isSubmitting}
                      text="Save"
                    />
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </div>
  );
}
